// Generado por generar.py — no editar a mano
window.CATALOGO_DG = {
  "edicion-aves": {
    "titulo": "EDICIÓN AVES (16 Lienzos)",
    "nombre": "EDICIÓN AVES",
    "precio": 109900,
    "antes": 189900,
    "variante": "42244232118326",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/Artboard1copy27_1200x_7c611534-bbe5-467f-9e3d-a0daa6a88867.jpg?v=1773347844",
    "temas": "aves pajaros tucan colibri cisne flamenco naturaleza regalo",
    "corto": "16 diseños de aves · 9.304 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Naturaleza"
    ],
    "afines": [
      "edicion-mariposas",
      "edicion-oceano",
      "edicion-plantas"
    ]
  },
  "edicion-museo": {
    "titulo": "EDICIÓN MUSEO (10 Lienzos)",
    "nombre": "EDICIÓN MUSEO",
    "precio": 99900,
    "antes": 167000,
    "variante": "41912439210038",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintura-gemas-museo-kit.jpg?v=1763706765",
    "temas": "museo arte van gogh mona lisa klimt picasso cuadros clasicos",
    "corto": "10 obras famosas · 8.640 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Arte y cosmos",
      "Noche y misterio"
    ],
    "afines": [
      "edicion-espacio",
      "edicion-gotica",
      "edicion-mariposas"
    ]
  },
  "edicion-museo-coleccionista": {
    "titulo": "MUSEO COLECCIONISTA (10 Lienzos · Caja edición especial)",
    "nombre": "MUSEO COLECCIONISTA",
    "precio": 119900,
    "antes": 179900,
    "variante": "47892149895222",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/museo-coleccionista-caja.jpg?v=1790478530",
    "temas": "museo coleccionista caja especial arte van gogh mona lisa klimt regalo",
    "corto": "10 obras famosas · 8.640 gemas de resina",
    "esEdicion": false,
    "familias": [],
    "afines": [
      "edicion-mariposas",
      "edicion-gotica",
      "edicion-arcoiris"
    ]
  },
  "edicion-mariposas": {
    "titulo": "EDICIÓN MARIPOSAS (15 Lienzos)",
    "nombre": "EDICIÓN MARIPOSAS",
    "precio": 99900,
    "antes": 167900,
    "variante": "42523118207030",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-gemas-mariposa.jpg?v=1773347844",
    "temas": "mariposas monarca colores naturaleza decoracion",
    "corto": "15 especies de mariposas · 11.788 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Naturaleza",
      "Color y fantasía"
    ],
    "afines": [
      "edicion-oceano",
      "edicion-arcoiris",
      "edicion-aves"
    ]
  },
  "edicion-gotica": {
    "titulo": "EDICIÓN GÓTICA (16 Lienzos)",
    "nombre": "EDICIÓN GÓTICA",
    "precio": 99900,
    "antes": 199700,
    "variante": "44306035146806",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintura-gemas-gotico-kit.jpg?v=1773347844",
    "temas": "gotica calaveras cuervos oscuro elegante halloween",
    "corto": "16 diseños góticos · 12.887 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Noche y misterio"
    ],
    "afines": [
      "edicion-museo",
      "edicion-espacio",
      "edicion-mariposas"
    ]
  },
  "edicion-arcoiris": {
    "titulo": "EDICIÓN ARCOÍRIS (16 Lienzos)",
    "nombre": "EDICIÓN ARCOÍRIS",
    "precio": 99900,
    "antes": 187900,
    "variante": "44295188414518",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintura-gemas-arcoiris-kit_5fdf89e2-3cd8-44cc-9124-8a8bb085c1f1.jpg?v=1773347844",
    "temas": "arcoiris unicornio sirena fantasia color rainbow niñas",
    "corto": "16 diseños de fantasía · 12.300 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Color y fantasía"
    ],
    "afines": [
      "edicion-mariposas",
      "edicion-oceano",
      "edicion-gotica"
    ]
  },
  "edicion-oceano": {
    "titulo": "EDICIÓN OCEANO (16 Lienzos)",
    "nombre": "EDICIÓN OCÉANO",
    "precio": 99900,
    "antes": 189900,
    "variante": "44306037604406",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintura-gemas-oceano-kit.jpg?v=1762461919",
    "temas": "oceano mar tortuga medusa tiburon ballena marino",
    "corto": "16 criaturas marinas · Más de 10.000 gemas",
    "esEdicion": true,
    "familias": [
      "Naturaleza",
      "Color y fantasía"
    ],
    "afines": [
      "edicion-mariposas",
      "edicion-arcoiris",
      "edicion-aves"
    ]
  },
  "edicion-plantas": {
    "titulo": "EDICIÓN PLANTAS (16 Lienzos)",
    "nombre": "EDICIÓN PLANTAS",
    "precio": 99900,
    "antes": 187900,
    "variante": "44314593656886",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintar-gemas-plantas-kit_1627e558-bb43-40fa-8146-3c74073694fa.jpg?v=1773347844",
    "temas": "plantas botanica suculenta cactus verde hogar",
    "corto": "16 diseños botánicos · 10.563 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Naturaleza"
    ],
    "afines": [
      "edicion-mariposas",
      "edicion-aves",
      "edicion-oceano"
    ]
  },
  "edicion-espacio": {
    "titulo": "EDICIÓN ESPACIO (10 Lienzos)",
    "nombre": "EDICIÓN ESPACIO",
    "precio": 99900,
    "antes": 167900,
    "variante": "44306048745526",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/kit-pintura-gemas-espacio-kit.jpg?v=1773347844",
    "temas": "espacio universo saturno galaxia nebulosa cosmos principiantes",
    "corto": "10 maravillas del cosmos · 9.000 gemas de resina",
    "esEdicion": true,
    "familias": [
      "Arte y cosmos",
      "Noche y misterio"
    ],
    "afines": [
      "edicion-museo",
      "edicion-gotica",
      "edicion-mariposas"
    ]
  },
  "edicion-especial-kuromi-40x50": {
    "titulo": "EDICIÓN ESPECIAL KUROMI (Lienzo 40 × 50 cm)",
    "nombre": "EDICIÓN ESPECIAL KUROMI",
    "precio": 119900,
    "antes": 179900,
    "variante": "47863917510710",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/terminado.jpg?v=1790270294",
    "temas": "kuromi sanrio edicion especial lienzo grande 40x50 rainbow escarchado",
    "corto": "1 diseño de Kuromi · +36.000 gemas cuadradas",
    "esEdicion": false,
    "familias": [],
    "afines": [
      "edicion-mariposas",
      "edicion-gotica",
      "edicion-arcoiris"
    ]
  },
  "set-de-boligrafo-ergonomico-de-resina-con-6-puntas-intercambiables": {
    "titulo": "Aplicador Ergonómico 6 en 1",
    "nombre": "Aplicador Ergonómico 6 en 1",
    "precio": 29900,
    "antes": 59900,
    "variante": "44592282861622",
    "imagen": "https://cdn.shopify.com/s/files/1/0589/7397/8678/files/Gemini_Generated_Image_r5p2u4r5p2u4r5p2_1.jpg?v=1765943526",
    "temas": "aplicador boligrafo herramienta accesorio ergonomico cabezales",
    "corto": "6 intercambiables · Gemas redondas y cuadradas",
    "esEdicion": false,
    "familias": [],
    "afines": [
      "edicion-mariposas",
      "edicion-gotica",
      "edicion-arcoiris"
    ]
  }
};
window.DUO_DG = {
  "precio": 149900,
  "especial": 49900,
  "dos": 49900,
  "aplicador": 0,
  "handleEspecial": "edicion-arcoiris",
  "gancho": "La segunda te queda en {precio}"
};
window.ENVIO_DG = {
  "umbral": 109900,
  "costo": 16000
};
